export const INITIAL_TIMESHEET_EVENT_FETCH = "INITIAL_TIMESHEET_EVENT_FETCH";
export const SET_TIMESHEET_EVENT_FILTERS = "SET_TIMESHEET_EVENT_FILTERS";
export const SET_TIMESHEET_EVENT_PAGE = "SET_TIMESHEET_EVENT_PAGE";
export const SET_TIMESHEET_EVENT_SEARCH = "SET_TIMESHEET_EVENT_SEARCH";
